import React, { useState, useRef, useEffect } from 'react'
// import { BsEmojiSmileFill } from 'react-icons/bs'
import { IoMdSend } from 'react-icons/io'
import styled from 'styled-components'
// import Picker from 'emoji-picker-react'
import { AiOutlineSchedule } from 'react-icons/ai'
import { TiDelete } from 'react-icons/ti'
// import AudioRecorder from '../../../Common/AudioRecorder'
import AudioRecorder from '../Common/AudioRecorder'
import { FaTrash } from 'react-icons/fa'
import { FaPaperclip } from 'react-icons/fa'
import { FiXCircle } from 'react-icons/fi'

export default function ChatInput({
    handleSendMsg,
    setShowSchedule,
    onScheduleClick,
    socket,
    clientId,
    setIsTyping,
    replyMessage,
    setReplyMessage,
    handleSendAudio,
    attachedFiles,
    setAttachedFiles,
}) {
    const [msg, setMsg] = useState('')

    // const [isTyping, setIsTyping] = useState(false); // To track if someone is currently typing
    const [selfTyping, setSelfTyping] = useState(false) // To track if the current user is typing
    const typingTimeoutRef = useRef(null) // To keep track of the setTimeout function
    let [
        audioUrl,
        isRecording,
        setIsRecording,
        startRecording,
        stopRecording,
        audioFile,
        setAudioFile,
        setAudioUrl,
    ] = AudioRecorder()

    useEffect(async () => {
        try {
            setMsg('')
            if (isRecording) {
                setIsRecording(false)
                await stopRecording()
            }
            setAudioFile(null)
        } catch (err) {
            console.log('err inside useeffect......', err)
        }
    }, [clientId])
    // if (audioFile) modifier({ audioFile, audioUrl })

    useEffect(() => {
        if (!socket) return
        socket.on('typing', handleOnSocketTyping)
        socket.on('stop_typing', handleOnSocketStopTyping)

        // socket.on(NEW_CHAT_EVENT, onNewChat);
        // socket.on(LEAVE_CHAT_EVENT, onChatLeave);
        return () => {
            // Remove all the event listeners we set up to avoid memory leaks and unintended behaviors.

            socket.off('typing', handleOnSocketTyping)
            socket.off('stop_typing', handleOnSocketStopTyping)
            //   socket.off(MESSAGE_RECEIVED_EVENT, onMessageReceived);
            //   socket.off(NEW_CHAT_EVENT, onNewChat);
        }
    }, [socket])

    const handleOnSocketTyping = (cId) => {
        // Check if the typing event is for the currently active chat.
        // if (clientId !== currentChat.current?._id) return;
        if (cId != clientId) return
        setIsTyping(true) // Set the typing state to true for the current chat.
    }

    const handleOnSocketStopTyping = (cId) => {
        // Check if the stop typing event is for the currently active chat.
        if (cId != clientId) return
        setIsTyping(false)
    }

    // const [showEmojiPicker, setShowEmojiPicker] = useState(false)
    // const handleEmojiPickerhideShow = () => {
    //     setShowEmojiPicker(!showEmojiPicker)
    // }

    // const handleEmojiClick = (emojiObject) => {
    //     let message = msg
    //     message += emojiObject.emoji
    //     setMsg(message)
    // }

    const sendChat = (event) => {
        event.preventDefault()
        if (msg.length > 0 || attachedFiles?.length >= 1) {
            handleSendMsg(msg)
            setMsg('')
        }
    }
    const sendAudio = () => {
        if (audioFile && audioUrl) {
            handleSendAudio(audioFile, audioUrl)
            setAudioFile(null)
            setAudioUrl('')
        }
    }
    const handleOnMessageChange = (e) => {
        setMsg(e.target.value)

        //  if (!socket || !isConnected) return; //........................

        // Check if the user isn't already set as typing
        const senderType = 'trainer'
        if (!selfTyping) {
            // Set the user as typing
            setSelfTyping(true)

            // Emit a typing event to the server for the current chat
            socket.emit('typing', { clientId, senderType })
        }
        // Clear the previous timeout (if exists) to avoid multiple setTimeouts from running
        if (typingTimeoutRef.current) {
            clearTimeout(typingTimeoutRef.current)
        }

        const timerLength = 3000
        // Set a timeout to stop the typing indication after the timerLength has passed
        typingTimeoutRef.current = setTimeout(() => {
            socket.emit('stop_typing', { clientId, senderType })
            setSelfTyping(false)
        }, timerLength)
    }
    // const handleKeyDown = (e) => {
    //     console.log("inside ")
    //     if (e.key === 'Enter' && e.ctrlKey) {
    //         console.log("inside both")
    //         setMsg((prevMsg) => prevMsg + '\n');
    //     }
    // }
    return (
        <Container>
            {replyMessage && (
                <div
                    className="reply-preview"
                    style={{
                        color: 'white',
                        display: 'flex',
                        justifyContent: 'space-between',
                        fontSize: '12px',
                        width: '70%',
                        backgroundColor: 'rgb(28, 29, 30)',
                        borderRadius: '9px',
                        minHeight: '32px',
                    }}
                >
                    {/* Render the content of the swiped message */}
                    <div style={{ marginLeft: '5px', marginTop: '2px' }}>
                        {/* {replyMessage.text} */}
                        {replyMessage?.text && replyMessage?.text != '' ? (
                            <span>{replyMessage.text}</span>
                        ) : replyMessage?.audioUrl ? (
                            <span role="img" aria-label="audio">
                                🔊
                            </span>
                        ) : replyMessage?.attachments &&
                          replyMessage?.attachments?.length > 0 ? (
                            <span role="img" aria-label="audio">
                                📄
                            </span>
                        ) : null}
                    </div>
                    {/* <button onClick={() => setReplyMessage(null)}>Cancel</button> */}
                    <div>
                        <TiDelete
                            onClick={() => setReplyMessage(null)}
                            style={{
                                fontSize: '15px',
                                color: 'white',
                                margin: '3px',
                            }}
                        />
                    </div>
                </div>
            )}
            {attachedFiles?.length > 0 ? (
                <div
                // className="grid gap-4 grid-cols-5 p-4 justify-start max-w-fit"
                >
                    {attachedFiles.map((file, i) => {
                        return (
                            <div
                                key={i}
                                // className="group w-32 h-32 relative aspect-square rounded-xl cursor-pointer"
                            >
                                <div
                                // className="absolute inset-0 flex justify-center items-center w-full h-full bg-black/40 group-hover:opacity-100 opacity-0 transition-opacity ease-in-out duration-150"
                                >
                                    <button
                                        onClick={() => {
                                            setAttachedFiles(
                                                attachedFiles.filter(
                                                    (_, ind) => ind !== i,
                                                ),
                                            )
                                        }}
                                        // className="absolute -top-2 -right-2"
                                    >
                                        <FiXCircle className="h-6 w-6 text-white" />
                                    </button>
                                </div>
                                <img
                                    style={{
                                        maxHeight: '100%',
                                        maxWidth: '100%',
                                    }}
                                    // className="h-full rounded-xl w-full object-cover"
                                    src={URL.createObjectURL(file)}
                                    alt="attachment"
                                />
                            </div>
                        )
                    })}
                </div>
            ) : null}
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                {!isRecording && !audioFile ? (
                    <>
                        <div className="button-container">
                            <div className="schedule-icon">
                                <AiOutlineSchedule onClick={onScheduleClick} />
                                {/* <BsEmojiSmileFill onClick={handleEmojiPickerhideShow} />
                                        {showEmojiPicker && (
                                            <Picker onEmojiClick={handleEmojiClick} />
                                        )} */}
                            </div>
                        </div>
                        <input
                            hidden
                            id="attachments"
                            type="file"
                            value=""
                            multiple
                            max={5}
                            onChange={(e) => {
                                if (e.target.files) {
                                    console.log(
                                        'e.target.files',
                                        e.target.files,
                                    )
                                    setAttachedFiles([...e.target.files])
                                }
                            }}
                        />
                        <label
                            htmlFor="attachments"
                            style={{ marginTop: '5px' }}
                            // className="p-4 rounded-full bg-dark hover:bg-secondary"
                        >
                            <FaPaperclip
                                className="w-5 h-5"
                                style={{
                                    marginRight: '5px',
                                    cursor: 'pointer',
                                }}
                            />
                        </label>
                        <form
                            className="input-container"
                            onSubmit={(event) => sendChat(event)}
                        >
                            <input
                                type="text"
                                placeholder="type your message here"
                                onChange={handleOnMessageChange}
                                value={msg}
                                // onKeyDown={handleKeyDown}
                            />
                            <button type="submit">
                                <IoMdSend />
                            </button>
                        </form>
                    </>
                ) : (
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                        }}
                    >
                        <audio
                            className="audio-player"
                            style={{ width: '190px' }}
                            src={
                                // audioUrl == ''
                                // exercise?.feedbackVoiceNoteUrl
                                audioUrl
                            }
                            controls
                        />
                        <IoMdSend
                            onClick={() => {
                                // Handle send logic here
                                sendAudio()
                            }}
                            style={{
                                fontSize: '25px',
                                color: 'white',
                                cursor: 'pointer',
                                margin: '5px',
                            }}
                        />

                        <FaTrash
                            onClick={async () => {
                                // Handle delete logic here
                                // stopRecording();
                                await stopRecording()
                                setAudioFile(null)
                                setAudioUrl('')
                            }}
                            style={{
                                fontSize: '15px',
                                color: 'white',
                                cursor: 'pointer',
                                margin: '5px',
                            }}
                        />
                    </div>
                )}

                <div
                    className="form-row"
                    style={{ display: 'flex', alignItems: 'center' }}
                >
                    {isRecording == false ? (
                        <img
                            src="/images/record.svg"
                            // src="../../../../images/record.svg"
                            height="18px"
                            onClick={startRecording}
                            style={{ marginLeft: '8px', cursor: 'pointer' }}
                        />
                    ) : (
                        <img
                            // className="col-md-2"
                            src="/images/stop.svg"
                            style={{ marginLeft: '5px', cursor: 'pointer' }}
                            height="18px"
                            onClick={() => {
                                stopRecording()
                                // setExercise({
                                //     ...exercise,
                                //     feedbackVoiceNoteUrl: audioFile,
                                // })
                            }}
                        />
                    )}
                </div>
            </div>
        </Container>
    )
}

const Container = styled.div`
    width: 100%;
    align-items: center;
    background-color: #101317;
    padding: 0 2rem;
    display: flex;
    flex-direction: column;
    padding: 10px;
    bottom: 0;
    position: absolute;
    // @media screen and (min-width: 720px) and (max-width: 1080px) {
    //     padding: 0 1rem;
    //     gap: 1rem;
    // }
    .button-container {
        display: flex;
        align-items: center;
        color: white;
        gap: 1rem;
        .schedule-icon {
            padding-right: 10px;
            position: relative;
            svg {
                font-size: 1.3rem;
                color: white;
                cursor: pointer;
            }
            .emoji-picker-react {
                position: absolute;
                top: -350px;
                background-color: #080420;
                box-shadow: 0 5px 10px #9a86f3;
                border-color: #9a86f3;
                .emoji-scroll-wrapper::-webkit-scrollbar {
                    background-color: #080420;
                    width: 5px;
                    &-thumb {
                        background-color: #9a86f3;
                    }
                }
                .emoji-categories {
                    button {
                        filter: contrast(0);
                    }
                }
                .emoji-search {
                    background-color: transparent;
                    border-color: #9a86f3;
                }
                .emoji-group:before {
                    background-color: #080420;
                }
            }
        }
    }
    .input-container {
        width: 100%;
        border-radius: 2rem;
        display: flex;
        align-items: center;
        gap: 1rem;
        background-color: #1f2731;
        input {
            width: 90%;
            height: 60%;
            background-color: transparent;
            color: white;
            border: none;
            padding-left: 1rem;
            font-size: 0.9rem;

            &::selection {
                background-color: #9a86f3;
            }
            &:focus {
                outline: none;
            }
        }
        button {
            padding: 0.3rem 1.2rem;
            border-radius: 2rem;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #101317;
            border: 1px solid #1f2731;
            @media screen and (min-width: 720px) and (max-width: 1080px) {
                padding: 0.3rem 1rem;
                svg {
                    font-size: 1rem;
                }
            }
            svg {
                font-size: 1.5rem;
                color: white;
            }
        }
    }
`
